import type {
  AddCartClickedAttributes,
  RemoveCartClickedAttributes,
} from '@glovo/perseus-events-perseus'
import { AddCartClicked, RemoveCartClicked } from '@glovo/perseus-events-perseus'

export const AddCartClickedEvent = (attributes: AddCartClickedAttributes) =>
  new AddCartClicked(attributes)

export const RemoveCartClickedEvent = (attributes: RemoveCartClickedAttributes) =>
  new RemoveCartClicked(attributes)
